/* eslint-disable eqeqeq */
import React from 'react'
import { GridColumns, useGridApiRef } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { Tooltip, Typography } from '@mui/material';
import { DataGridMuiClientImport } from 'components/Common/Table/DataGridMuiClientImport';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { VscPassFilled } from "react-icons/vsc";
import { MdCancel } from "react-icons/md";

const TbRequest = (props) => {

    const { DataRow, isLoadingTable, isAfterSubmit } = props;
    const apiRef = useGridApiRef();

    const IconWarning = () => {
        return (
            <Tooltip title={"ข้อมูลไม่ถูกต้อง"} placement="top">
                <Typography variant="body2" >
                    <WarningRoundedIcon style={{ color: '#ffc107', fontSize: '18px' }} />
                </Typography>
            </Tooltip>
        )
    }

    const IconRequire = () => {
        return (
            <Tooltip title={"ข้อมูลบังคับใส่"} placement="top">
                <Typography variant="body2" >
                    <WarningRoundedIcon style={{ color: '#ed1c24', fontSize: '18px' }} />
                </Typography>
            </Tooltip>
        )
    }


    const IconPass = () => {
        return (
            <Tooltip title={"ผ่าน"} placement="top">
                <Typography variant="body2" >
                    <VscPassFilled style={{ color: '#00c300', fontSize: '18px' }} />
                </Typography>
            </Tooltip>
        )
    }

    const IconNotPass = () => {
        return (
            <Tooltip title={"ไม่ผ่าน"} placement="top">
                <Typography variant="body2" >
                    <MdCancel style={{ color: '#ed1c24', fontSize: '18px' }} />
                </Typography>
            </Tooltip>
        )
    }

    const dataColumn: GridColumns = [
        {
            field: "nRow",
            headerName: "ที่",
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
            renderCell: (params) => apiRef.current.getRowIndex(params.row.sID) + 1
        },
        {
            field: "StatusRowIsPass",
            headerName: "#",
            headerAlign: "center",
            width: 40,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
            renderCell: (params) => {
                let IsPass = params.value;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {IsPass ? IconPass() : IconNotPass()}
                    </div>
                )
            },
        },
        {
            field: "sVOCFormCode",
            headerName: "เลขที่ใบแจ้ง",
            headerAlign: "center",
            width: 180,
            editable: false,
            resizable: false,
            disableReorder: true,
            align: "center",
            sortable: false,
            hide: !isAfterSubmit
        },
        {
            field: "sCustomerName",
            headerName: "ลูกค้า",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusCustomer;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sCompanyName",
            headerName: "บริษัท",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusCompany;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sAddress",
            headerName: "ที่อยู่/สถานที่เกิดเหตุ",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 220,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusAddress;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sAddressManual",
            headerName: "ที่อยู่(Manual)",
            headerAlign: "center",
            flex: 3,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 220,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussAddressManual;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sBA",
            headerName: "กลุ่มตลาด",
            headerAlign: "center",
            flex: 1.5,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusBA;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sTypeOfVOC",
            headerName: "Type of VOC",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusVOC;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sTypeOfVOCService",
            headerName: "Type of Service",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusVOCService;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sOtherTypeOfVOCService",
            headerName: "Type of Service (อื่นๆ)",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusVOCServiceOther;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sDetailIssue",
            headerName: "รายละเอียดที่แจ้ง",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 250,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusDetailIssue;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sTel",
            headerName: "หมายเลขโทรศัพท์",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusTel;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "IsContact",
            headerName: "ยินดีให้ติดต่อกลับทางโทรศัพท์",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 120,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusIsContact;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value == true ? "ใช่" : params.value == false ? "ไม่" : ""}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sContact",
            headerName: "ช่องทางการติดต่อ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussContact;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "dIssueDate",
            headerName: "วันที่แจ้ง",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusDateIssue;
                let textdate = params.value != null ? moment(params.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {textdate}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sRequestType",
            headerName: "ประเภทข้อร้องขอ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusRequest;
                return (
                    <div style={{ display: 'flex', gap: '4px', overflow: 'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sRequestTypeOther",
            headerName: "ประเภทข้อร้องขอ (อื่นๆ)",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusRequestOther;
                return (
                    <div style={{ display: 'flex', gap: '4px', overflow: 'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sResponType",
            headerName: "ประเภทผู้รับผิดชอบ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusResponType;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sUnitResponPIS",
            headerName: "ผู้รับผิดชอบ(หน่วยงาน)",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusUnitRespon;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sEmpResponPIS",
            headerName: "ผู้รับผิดชอบ(บุคคล)",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusEmpRespon;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sOtherPTT",
            headerName: "ผู้รับผิดชอบ(หน่วยงานภายนอก ปตท.)",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusOutPTTRespon;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sInputOtherPTT",
            headerName: "ผู้รับผิดชอบ(หน่วยงานภายนอก ปตท.) อื่นๆ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 220,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatusOtherOutPTTRespon;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sStatus",
            headerName: "สถานะใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => {
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sDetailResolved",
            headerName: "รายละเอียดการแก้ไข/ดำเนินตามคำร้อง",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 250,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussDetailResolved;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "dCreate",
            headerName: "วันที่เปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussDateCreate;
                let textdate = params.value != null ? moment(params.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {textdate}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "dResolved",
            headerName: "วันที่แก้ไขแล้วเสร็จ",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussDateResolved;
                let textdate = params.value != null ? moment(params.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {textdate}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "dClosed",
            headerName: "วันที่ปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "left",
            resizable: true,
            disableReorder: true,
            minWidth: 180,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussDateClosed;
                let textdate = params.value != null ? moment(params.value).add(543, 'year').format("DD/MM/YYYY HH:mm น.") + "" : null;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {textdate}
                        </Typography>
                    </div>
                )
            },
        },
        {
            field: "sScore",
            headerName: "คะแนน",
            headerAlign: "center",
            flex: 1,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 130,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussScore;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
        
        {
            field: "sEmpCreate",
            headerName: "ผู้เปิดใบงาน",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 150,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussEmpCreate;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value}
                        </Typography>
                    </div>
                )
            },
        },
       
        {
            field: "IsSendmail",
            headerName: "ส่งอีเมลแจ้งเตือนลูกค้า",
            headerAlign: "center",
            flex: 2,
            align: "center",
            resizable: true,
            disableReorder: true,
            minWidth: 200,
            sortable: true,
            renderCell: (params) => {
                let nStatusColumn = params.row?.nColStatussIsSendmail;
                return (
                    <div style={{ display: 'flex', gap: '4px',overflow:'hidden' }}>
                        {nStatusColumn == 1 ? IconWarning() : nStatusColumn == 2 ? IconRequire() : null}
                        <Typography variant="body2" >
                            {params.value == true ? "ใช่" : params.value == false ? "ไม่" : ""}
                        </Typography>
                    </div>
                )
            },
        },
    ];

    return (
        <>
            <DataGridMuiClientImport
                isLoading={isLoadingTable}
                rows={DataRow}
                HiddenToolHead={true}
                Columns={dataColumn}
                RefAPI={apiRef}
                backgroundHeaderCustom={"#004290"}
                sxCustomHeader={{ color: '#ffffff' }}
                initialState={{
                    pinnedColumns: { left: ['nRow', 'StatusRowIsPass', 'sVOCFormCode', 'sCustomerName', 'sCompanyName'] }
                }}
            />
        </>
    )
}

export default TbRequest